"use strict";
/**
 * Schémas Zod pour les actions IA génériques
 * (Distinction avec les domaines métier: dts, opportunities, interview-prep)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateTextSchema = void 0;
const zod_1 = require("zod");
/**
 * Schéma pour la traduction de texte
 * Output: Texte traduit dans la langue cible
 */
exports.translateTextSchema = zod_1.z.object({
    translatedText: zod_1.z.string().describe('Texte traduit'),
});
